import {ResourceAccessRole, ResourceData, ResourceNode, ResourceNodes, ResourceType} from "./types";
import {DirectoryOrgUnitRoot} from "../shared/directory/types";
import {BaseApp} from "../shared/BaseApp";
import {BaseFyneAIAppPrefs} from "./BaseFyneAIAppPrefs";
import {User} from "@firebase/auth";

export async function FyneAIInit(user: User, role?: ResourceAccessRole): Promise<void> {
  const resNodes = ResourceNodes.getInstance(role);
  const nodeItems = await resNodes.getOrLoadListItems();
  let org: ResourceNode = nodeItems?.find(item => item.type === ResourceType.ORGANIZATION);
  if (!org) {
    const dirOrg = await DirectoryOrgUnitRoot.load();
    org = ResourceNode.createNewOrganizationResource(dirOrg);
    await resNodes.addListItem(org);
  }
  const appPrefs = BaseApp.CONTEXT.getAppPrefs<BaseFyneAIAppPrefs>();
  let selectedResId = appPrefs.getSelectedResourceId();
  if (!selectedResId || !nodeItems.find(node => node.id === selectedResId)) {
    selectedResId = org.id;
    appPrefs.setSelectedResourceId(selectedResId);
  }
  const node = await resNodes.getOrLoadItem(selectedResId);
  switch (node.type) {
    case ResourceType.PROJECT:
      await ResourceData.createAndInitProject(node.getResource());
      break;
    case ResourceType.ORGANIZATION:
      await ResourceData.createAndInitOrganization(node.getResource());
      break;
  }
}